import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);

    return next(req).pipe(
        catchError((error) => {
            console.error('Erreur HTTP:', error);

            const isLoginRequest = req.url.includes('/auth/login');
            if (!isLoginRequest && (error.status === 401 || error.status === 403)) {
                console.log('Non authentifié, redirection vers login');
                router.navigate(['/auth/login']);
            }

            return throwError(() => error);
        })
    );
};